import angular from 'angular'
import routers from './routers.js'
import refundServiceChargeTaskTrackCtrl from './refundServiceChargeTaskTrackCtrl.js'
import fieldConfig from './fieldConfig'

export default angular
  .module('declaration.personalIncomeTax.refundServiceChargeTaskTracking', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .value('RSCTT_fieldConfig', fieldConfig)
  .controller('refundServiceChargeTaskTrackCtrl', refundServiceChargeTaskTrackCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/refundServiceChargeTaskTracking/index.js